"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const libConfig_1 = __importDefault(require("./libConfig"));
const round_1 = __importDefault(require("./round"));
function getDisplayRoundNumber(value, rounding = libConfig_1.default.rounding) {
    const roundedValue = (0, round_1.default)(value, rounding.type, rounding.digits);
    if (rounding.minFractionDigits !== undefined) {
        return roundedValue.toFixed(Math.max(rounding.minFractionDigits, rounding.digits));
    }
    return String(roundedValue);
}
exports.default = getDisplayRoundNumber;
//# sourceMappingURL=getDisplayRoundNumber.js.map